<template>
  <div style="margin-bottom: 10px">

    <el-card class="box-card" style="margin-top: 3px">
      <el-form label-position="left" label-width="180px" size="mini">
        <!-- 每天的各个抽奖时间（逗号分隔） -->
        <el-form-item label="每天的各个抽奖时间：">
          <el-input v-model="data.lotteryTimes" placeholder="比如“08:00, 11:00, 14:00, 17:00”（各个时间之间用半角逗号隔开）" style="width: 550px"></el-input>
        </el-form-item>

        <!-- 每次抽奖时抽几个人 -->
        <el-form-item label="每次抽奖时抽几个人：">
          <el-input v-model="data.lotteryPickNumber" placeholder="正整数" style="width: 150px"></el-input>
        </el-form-item>

        <!-- 每天何时发放保底奖励 -->
        <el-form-item label="每天何时发放保底奖励：">
          <el-input v-model="data.guaranteedRewardsTime" placeholder="比如“22:00”" style="width: 150px"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 各个许愿槽 -->
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>许愿槽</span>
        <el-button style="float: right" type="primary" icon="el-icon-plus"
          @click="openEditWishSlotDialog(true, null)">新增许愿槽</el-button>
      </div>
      <el-table :data="data.wishSlots" border size="small" style="width: 901px; margin-top: 10px">
        <el-table-column label="解锁条件（付费参与人数）" align="center" width="100" show-overflow-tooltip>
          <template scope="scope">
            {{ scope.row.requiredPaidPlayerNumber }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="抽奖池" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.rewardPool" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="保底奖励" align="center" width="350">
          <template scope="scope">
            <ShowItems :items="scope.row.guaranteedRewards" />
          </template>
        </el-table-column>        
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <span class="link-button" style="color: red" @click="removeWishSlot(scope.$index)">删除</span>
            <span class="link-button" @click="openEditWishSlotDialog(false, scope.row, scope.$index)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import ShowItems from "@/pages/activity/activity_parameter_template/components/ShowItems";
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

export default {
  data() {
    return {
      data: {
        wishSlots: [], // 各个许愿槽
        lotteryTimes: "", // 每天的各个抽奖时间（逗号分隔）
        lotteryPickNumber: 0, // 每次抽奖时抽几个人
        guaranteedRewardsTime: "", // 每天何时发放保底奖励
      },
    };
  },

  components: {
    ShowItems,
    BaseItemSelector,
  },

  props: {
    parameters: "",
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    if (this.parameters) {
      this.data = JSON.parse(this.parameters);
    }
  },

  methods: {
    async updatedParam() {
      let outputData = {};
      Object.assign(outputData, this.data);

      outputData.lotteryPickNumber = parseInt(outputData.lotteryPickNumber) || 0;

      this.$emit("updated", JSON.stringify(outputData), async() => {
        {
          let strs = outputData.lotteryTimes.split(",");
          for (let str of strs) {
            if (!this.isValidDayTime(str.trim())) {
              return {errMsg: "抽奖时间的格式不正确"};
            }
          }
        }

        if (!this.isValidDayTime(outputData.guaranteedRewardsTime)) {
          return {errMsg: "“每天何时发放保底奖励”的格式不正确"};
        }
      });
    },

    isValidDayTime(str) {
      // 正则表达式，匹配HH:MM 或 HH:MM:SS 格式
      const regex1 = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/; // 匹配 HH:MM
      const regex2 = /^([01]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/; // 匹配 HH:MM:SS

      // 测试字符串是否匹配任一正则表达式
      return regex1.test(str) || regex2.test(str);
    },

    async openEditWishSlotDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditWish2ActivityWishSlotDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.wishSlots.push(param);
            } else {
              this.$set(that.data.wishSlots, index, param);
            }

            await this.updatedParam();
          }
        },
        data: {
          isCreated: isCreated,
          entry: entry,
        },
      });
    },

    async removeWishSlot(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除第${1+index}许愿槽？`
        );
        this.data.rebateGears.splice(index, 1);

        await this.updatedParam();
      } catch (error) { }
    },    
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>